import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2563EB', // Enterprise Indigo/Blue
      light: '#3B82F6',
      dark: '#1D4ED8',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0F172A', // Deep Slate
      light: '#1E293B',
      dark: '#070D19',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#06B6D4', // Cyan AI accent
    },
    success: {
      main: '#10B981', // Emerald growth accent
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#475569',
      disabled: '#94A3B8',
    },
    divider: 'rgba(15, 23, 42, 0.08)',
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Geist", "Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 800,
      lineHeight: 1.12,
      letterSpacing: '-0.03em',
      color: '#0F172A',
      '@media (max-width:900px)': {
        fontSize: '2.6rem',
      },
      '@media (max-width:600px)': {
        fontSize: '2.1rem',
      },
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.18,
      letterSpacing: '-0.025em',
      color: '#0F172A',
      '@media (max-width:900px)': {
        fontSize: '2rem',
      },
      '@media (max-width:600px)': {
        fontSize: '1.65rem',
      },
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.25,
      letterSpacing: '-0.02em',
      color: '#0F172A',
      '@media (max-width:600px)': {
        fontSize: '1.35rem',
      },
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.35,
      color: '#0F172A',
    },
    body1: {
      fontSize: '1.0625rem', // 17px body
      lineHeight: 1.65,
      color: '#334155',
    },
    body2: {
      fontSize: '0.9375rem', // 15px supporting text
      lineHeight: 1.6,
      color: '#64748B',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.01em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          padding: '10px 22px',
          fontSize: '0.95rem',
          boxShadow: 'none',
          transition: 'all 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
          '&:hover': {
            boxShadow: '0 8px 20px -4px rgba(37, 99, 235, 0.3)',
            transform: 'translateY(-1px)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)',
        },
        containedSecondary: {
          background: '#0F172A',
          color: '#FFFFFF',
          '&:hover': {
            background: '#1E293B',
            boxShadow: '0 8px 20px -4px rgba(15, 23, 42, 0.3)',
          },
        },
        outlinedPrimary: {
          borderColor: 'rgba(37, 99, 235, 0.3)',
          color: '#2563EB',
          '&:hover': {
            borderColor: '#2563EB',
            backgroundColor: 'rgba(37, 99, 235, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 10px 30px -5px rgba(15, 23, 42, 0.06)',
          border: '1px solid rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
